var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [_vm._t("default", null, null, { onShare: _vm.onShare })], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }